import { useParams } from 'react-router-dom';
import { TicketDetail } from '../../features/ticket/TicketDetail';

export function TicketPage() {
  const { ticketId } = useParams();
  if (!ticketId) return null;
  return <TicketDetail ticketId={ticketId} />;
}
